<div class="flex flex-col">
    @if (title) {
        <div class="header-x-small-bold" [translate]="title"></div>
    }
    @if (subtitle) {
        <div
            class="body-copy"
            [translate]="hasInvoiceViaEmail ? 'userProfile.paymentDetails.businessInvoice.sigendSubtitle' : subtitle"
        ></div>
    }

    <!-- Handle subscribe/unsubscribe buttons -->
    <div class="flex justify-between mt-30px">
        @if (hasInvoiceViaEmail) {
            <div class="subscribed flex flex-col">
                <span class="label body-header" translate="userProfile.paymentDetails.businessInvoice.email"></span>
                <span class="body-copy">{{ invoiceViaEmail }}</span>
            </div>
        }
        @if (subscribeButton && !hasInvoiceViaEmail) {
            <app-evida-button class="button" type="primary" (clicked)="onEditInvoiceEmailForm(false)">
                {{ subscribeButton | translate }}
            </app-evida-button>
        }

        @if (hasInvoiceViaEmail) {
            <div class="edit-button" (click)="onEditInvoiceEmailForm(true)">
                <mat-icon svgIcon="evida_edit" inline="true"></mat-icon>
            </div>
        }
    </div>
</div>
